import type { TikTokEventPropertiesTemplate } from './constants';

export enum TikTokEvent {
  AddToCart = 'AddToCart',
  CompleteRegistration = 'CompleteRegistration',
  InitiateCheckout = 'InitiateCheckout',
  ViewContent = 'ViewContent',
  LegacyCheckout = 'Checkout',
  // CompletePayment is new event on checkout success page
  CompletePayment = 'CompletePayment',
}

export interface TikTokHashedData {
  sha256_email?: string;
  sha256_phone_number?: string;
  eventId?: string;
}

export interface TikTokBaseUserDataArgs extends Record<string, unknown> {
  event_id?: string;
  email?: string;
  phone?: string;
}

export interface TikTokPaymentDataArgs extends TikTokBaseUserDataArgs {
  value?: string;
}

export interface TikTokBaseEventProperties
  extends TikTokEventPropertiesTemplate {
  event_id?: string;
}

export interface TikTokCompletePaymentProperties
  extends TikTokBaseEventProperties {
  event_id?: string;
  value?: string;
  currency?: string;
}

export interface TikTokIdentifyData {
  email?: string;
  phone?: string;
}

export interface TikTokMounter {
  page?: () => void;
  track: (eventName: TikTokEvent, properties: Record<string, unknown>) => void;
  identify: (data?: TikTokHashedData) => void;
}
